module.exports = __webpack_public_path__ + "static/media/1POLICY39.49599a94.jpg";